import { memo } from 'react';
import { ShoppingCart } from 'lucide-react';

interface PedidosEmptyStateProps {
  hasActiveFilters: boolean;
  onAddPedido: () => void;
}

export const PedidosEmptyState = memo<PedidosEmptyStateProps>(({
  hasActiveFilters,
  onAddPedido
}) => {
  return (
    <div className="text-center py-12">
      <ShoppingCart className="w-16 h-16 text-slate-300 mx-auto mb-4" />
      <p className="text-slate-500">
        {hasActiveFilters ? 'No hay pedidos con los filtros seleccionados' : 'No hay pedidos registrados'}
      </p>
      {!hasActiveFilters && (
        <button
          onClick={onAddPedido}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Agregar Primer Pedido
        </button>
      )}
    </div>
  );
});
